import React, { useEffect } from 'react';

import { Navigate, Route, Routes, useLocation, } from 'react-router-dom';
import './App.css';

import { HomePage } from './pages/home';

import './i18n'

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}


function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route index element={<HomePage />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
